import {
  COMPENSATION_PERIOD_LABELS,
  EMPLOYMENT_TYPE_LABELS,
  WORKPLACE_TYPE_LABELS,
} from '@absurd-careers/shared';
import type { EmploymentType, JobCompensation, WorkplaceType } from '@absurd-careers/shared';

export function formatWorkplaceType(value: WorkplaceType): string {
  return WORKPLACE_TYPE_LABELS[value];
}

export function formatEmploymentType(value: EmploymentType): string {
  return EMPLOYMENT_TYPE_LABELS[value];
}

/** `$150,000 – $190,000 per year`. Returns null when nothing is publishable. */
export function formatCompensation(compensation: JobCompensation | null): string | null {
  if (!compensation) return null;
  const { min, max, currency, period } = compensation;
  if (min == null && max == null) return null;

  const format = (amount: number) =>
    new Intl.NumberFormat('en-US', {
      style: currency ? 'currency' : 'decimal',
      currency: currency ?? undefined,
      maximumFractionDigits: 0,
    }).format(amount);

  const range =
    min != null && max != null && min !== max
      ? format(min) + ' – ' + format(max)
      : format((min ?? max) as number);

  return period ? range + ' ' + COMPENSATION_PERIOD_LABELS[period] : range;
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '';
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(iso));
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(iso));
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
}
